import { gql } from "@apollo/client";

export const GET_AND_UPDATE_REQUESTS = gql`
  mutation ($refresh: Boolean) {
    syncRequests(refresh: $refresh) {
      success
      message
    }
  }
`;
export const REFRESH_WONDE_SCHOOLS = gql`
  mutation RefreshWondeSchools {
    refreshWondeSchools {
      success
      message
      job {
        id
        status
        progress
        message
        jobType {
          jobType
        }
      }
    }
  }
`;
export const START_SCHOOL_SYNC_MUTATION = gql`
  mutation ($school: ID!) {
    schoolSyncStarted(school: $school) {
      success
      message
      syncRequest {
        id
        lastUpdated
        needsAction
        inProgress
        completed
        school {
          id
          name
          emailDomains {
            domain
          }
          subscriptionStatus
        }
        syncStatus
      }
    }
  }
`;
export const FETCH_SCHOOL_CLASSES = gql`
  mutation ($school: ID!) {
    fetchSchoolClasses(school: $school) {
      success
      message
    }
  }
`;

export const REQUEST_ACCESS = gql`
  mutation (
    $school: ID!
    $subscriptionType: String!
    $domains: [String]!
    $contacts: String!
  ) {
    requestWondeAccess(
      school: $school
      subscriptionType: $subscriptionType
      domains: $domains
      contacts: $contacts
    ) {
      success
      message
    }
  }
`;
